export const deliveriesTableBodyData = [
    {
        particular:"On Time Delivery",
        value:80,
    },
    {
        particular:"Delayed Delivery",
        value:15,
    }
]